import { z } from 'zod';

// QuoteTemplateLineItem Schema
export const QuoteTemplateLineItemSchema = z.object({
  ntiid: z.number().optional(),
  ntitrackingid: z.string().nullable().optional(),
  ntitype: z.string().nullable(),
  ntititle: z.string().nullable(),
  ntidesc: z.string().nullable(),
  ntiqty: z.number().nullable(),
  ntiunit: z.string().nullable(),
  nticost: z.string().nullable(),
  ntimarkup: z.string().nullable(),
  ntitax: z.number().nullable(),
  mid: z.number().nullable(),
  miid: z.number().nullable(),
  mpid: z.number().nullable(),
  lcid: z.string().nullable(),
  ltid: z.string().nullable(),
  mstyle: z.string().nullable().optional(),
  ntitypeid: z.number().nullable(),
  ntiorder: z.number().nullable(),
  ntisectionid: z.number().nullable().optional(),
  ntimfid: z.number().nullable().optional(),
  ntiparenttexttrackingid: z.string().nullable().optional(),
});

// QuoteTemplate Schema
export const QuoteTemplateSchema = z.object({
  ntid: z.number().optional(),
  nttitle: z.string().nullable(),
  ntmarket: z.string().nullable(),
  ntaccess: z.number().nullable(),
  ntview: z.string().nullable(),
  ntwotype: z.string().nullable(),
  lineItems: z.array(QuoteTemplateLineItemSchema),
  nttype: z.string().nullable(),
  ntcat: z.string().nullable(),
  ntdetail: z.string().nullable(),
  ntlineitems: z.number().nullable(),
});

export const QuoteTemplateSectionApiSchema = z.object({
  ntsid: z.number().optional(),
  ntstrackingid: z.string().nullable().optional(),
  ntswotype: z.string().nullable(),
  ntsntid: z.number(),
  ntscruid: z.number().nullable(),
  ntsname: z.string(),
  ntsorder: z.number()
});

export type QuoteTemplateSectionApi = z.infer<typeof QuoteTemplateSectionApiSchema>;

export const QuoteTemplateSectionsApiSchema = z.array(QuoteTemplateSectionApiSchema); 

// Create schemas (omit auto-generated fields)
export const CreateQuoteTemplateLineItemSchema = QuoteTemplateLineItemSchema.omit({ ntiid: true });
export const CreateQuoteTemplateSchema = QuoteTemplateSchema.omit({ ntid: true });

// Update schemas (make all fields optional except ID)
export const UpdateQuoteTemplateLineItemSchema = QuoteTemplateLineItemSchema.partial().required({ ntiid: true });
export const UpdateQuoteTemplateSchema = QuoteTemplateSchema.partial().required({ ntid: true });

// Type definitions
export type QuoteTemplateLineItem = z.infer<typeof QuoteTemplateLineItemSchema>;
export type QuoteTemplate = z.infer<typeof QuoteTemplateSchema>;
export type CreateQuoteTemplateLineItem = z.infer<typeof CreateQuoteTemplateLineItemSchema>;
export type CreateQuoteTemplate = z.infer<typeof CreateQuoteTemplateSchema>;
export type UpdateQuoteTemplateLineItem = z.infer<typeof UpdateQuoteTemplateLineItemSchema>;
export type UpdateQuoteTemplate = z.infer<typeof UpdateQuoteTemplateSchema>; 